import { render } from "./MailTemplate.vue?vue&type=template&id=095bbaa1&scoped=true"
import script from "./MailTemplate.vue?vue&type=script&lang=js"
export * from "./MailTemplate.vue?vue&type=script&lang=js"

import "./MailTemplate.vue?vue&type=style&index=0&id=095bbaa1&scoped=true&lang=css"

import exportComponent from "/home/projects/frontend.vendor-mailing-system.pravin/vendor-mailig-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-095bbaa1"]])

export default __exports__